import { BarChart, Users, Activity } from 'lucide-react';

export const dashboards = [
  {
    name: 'Metrics Dashboard',
    path: '/admin/metrics',
    icon: Activity,
    description: 'Comprehensive system, business, and application metrics.'
  },
  {
    name: 'User Analytics',
    path: '/admin/dashboards/user-analytics',
    icon: Users,
    description: 'Insights into user behavior, demographics, and engagement.'
  },
  {
    name: 'Sales Dashboard',
    path: '/admin/dashboards/sales',
    icon: BarChart,
    description: 'Track sales, revenue, and subscription data.'
  }
]; 